<template>
	<frontend-layout>
		<Head>
			<title>{{ $t("reportProblem") }} - {{ $t("siteTitle") }}</title>
		</Head>
		<section>
			<!-- Contact -->
			<div id="contact" class="form-1">
				<div class="container">
					<div class="row">
						<div class="col-lg-12">
							<h2 class="h2-heading">
								<span>{{ $t("reportProblem") }}</span>
								<br />
								<br />
								{{ $t("support.detail1") }}
							</h2>
							<p class="p-heading">
								{{ $t("support.detail3") }}
							</p>
							<p class="p-heading">
								{{ $t("support.detail2") }}
							</p>
							<br />
							<br />
							<InertiaLink
								class="btn btn-primary btn-lg"
								href="/docs"
								:title="$t('see') + ' ' + $t('document')"
								target="_blank"
								>{{ $t("document") }}</InertiaLink
							>
							<br />
							<br />
							<a
								class="btn btn-warning btn-lg"
								href="https://ncu.edu.tw/SD/msg_board/create"
								:title="
									$t('newTab') +
									$t('goto') +
									' ' +
									$t('NCU') +
									' ' +
									$t('support.SD') +
									' ' +
									$t('website')
								"
								target="_blank"
								>{{ $t("support.SD") }}</a
							>
						</div>
						<!-- end of col -->
					</div>
				</div>
			</div>
		</section>
	</frontend-layout>
</template>
<script>
// import components
import FrontendLayout from "@/Frontend/Shared/Layout";

export default {
	name: "index",
	data() {
		return {};
	},
	methods: {},
	mounted() {},
	components: {
		FrontendLayout,
	},
};
</script>
<style scoped></style>
